<template>
    <client-page class="wrap--main">
        <!-- 메인 비주얼 -->
        <div class="visual d-flex align-center color-white">
            <v-container>
                <div class="text-ani-wrap">
                    <div class="text-ani mb-6 mb-lg-18">
                        <p class="page-text font-weight-bold">
                            전자혁신제조플랫폼
                        </p>
                    </div>
                    <div class="text-ani">
                        <h2 class="tit--lg line-height-11">
                            한국전자정보통신산업진흥회
                        </h2>
                    </div>
                    <div class="text-ani mb-16 mb-lg-34">
                        <h2 class="tit--lg line-height-11">
                            (KEA) 전자제조센터
                        </h2>
                    </div>
                    <div class="text-ani">
                        <h5 class="tit-txt font-weight-regular">
                            설계, 개발, 제작, 조립, 검사를 지원기업과 <b class="font-size-18 font-size-md-24">공동진행</b>합니다.
                        </h5>
                    </div>
                </div>
            </v-container>
        </div>

        <section class="section">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit--lg line-height-1 font-weight-bold mb-8 mb-lg-20">
                        CATEGORY
                    </h2>
                    <h5 class="tit-txt font-weight-regular">
                        간편한 클릭으로 원하는 페이지로 이동하세요
                    </h5>
                </div>
                <v-row>
                    <v-col cols="12" sm="6" lg="3">

                        <main-card-icon
                        link="/join/type"
                        tit="회원가입"
                        sc="기업회원 · 일반회원"
                        icon="/images/main/s1-icon1.png">
                        </main-card-icon>

                    </v-col>
                    <v-col cols="12" sm="6" lg="3">

                        <main-card-icon
                        link="/service/about"
                        tit="e만듦"
                        sc="전자제조지원 서비스"
                        icon="/images/main/s1-icon2.png">
                        </main-card-icon>

                    </v-col>
                    <v-col cols="12" sm="6" lg="3">

                        <main-card-icon
                        link="https://yknowledge.uxi.kr/"
                        target="_blank"
                        tit="e이음"
                        sc="전문가 · 기업연결"
                        icon="/images/main/s1-icon3.png">
                        </main-card-icon>

                    </v-col>
                    <v-col cols="12" sm="6" lg="3">

                        <main-card-icon
                        link="https://goecircle.kr/"
                        target="_blank"
                        tit="e바꿈"
                        sc="피드백·스케일업"
                        icon="/images/main/s1-icon4.png">
                        </main-card-icon>

                    </v-col>
                </v-row>
            </v-container>
        </section>

        <v-container>
            <v-divider></v-divider>
        </v-container>

        <section class="section">
            <v-container>
                <v-row>
                    <v-col cols="12" lg="5" class="mb-40 mb-lg-0">
                        <tit-primary
                        className="mb-20 mb-lg-74"
                        sc="COMMUNITY"
                        tit="한국전자정보통신산업진흥회의 다양한 소식을 확인해 보세요. ">
                        </tit-primary>
                        <arrow-btn link="/community/notice"></arrow-btn>
                    </v-col>
                    <v-col cols="12" lg="7">
                        <div class="main-board-wrap pl-lg-42">
                            <v-tabs v-model="tab" height="36">
                                <v-tab>공지사항</v-tab>
                                <v-tab>자료실</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab">
                                <!-- S: 공지사항 -->
                                <v-tab-item>
                                    <main-notice />
                                </v-tab-item>
                                <!-- E: 공지사항 -->
                                <!-- S: 자료실 -->
                                <v-tab-item>
                                    <main-reference />
                                </v-tab-item>
                                <!-- E: 자료실 -->
                            </v-tabs-items>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="section" style="background-image: url(/images/main/s3-bg.jpg)">
            <v-container>
                <div class="tit-wrap">
                    <v-row align-lg="end">
                        <v-col col="12" lg="auto" class="mb-10 mb-lg-0">
                            <tit-primary
                            className="mb-0"
                            sc="Partners"
                            tit="KEA 산업혁신 파트너 ">
                            </tit-primary>
                        </v-col>
                        <v-spacer class="d-none d-lg-block"></v-spacer>
                        <v-col cols="12" lg="auto" class="d-flex">
                            <v-btn icon x-large class="slide-btn slide-btn--prev mr-4 mr-lg-8"><i class="icon icon-left-arrow"></i></v-btn>
                            <v-btn icon x-large class="slide-btn slide-btn--next"><i class="icon icon-right-arrow"></i></v-btn>
                        </v-col>
                    </v-row>
                </div>
                <div class="partners-slide">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="thumb-wrap mb-10 mb-lg-20">
                                    <div class="thumb" style="background-image: url(/images/main/partner1.jpg)"></div>
                                </div>
                                <div class="thumb-wrap">
                                    <div class="thumb" style="background-image: url(/images/main/partner2.jpg)"></div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="thumb-wrap mb-10 mb-lg-20">
                                    <div class="thumb" style="background-image: url(/images/main/partner3.jpg)"></div>
                                </div>
                                <div class="thumb-wrap">
                                    <div class="thumb" style="background-image: url(/images/main/partner4.jpg)"></div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="thumb-wrap mb-10 mb-lg-20">
                                    <div class="thumb" style="background-image: url(/images/main/partner5.jpg)"></div>
                                </div>
                                <div class="thumb-wrap">
                                    <div class="thumb" style="background-image: url(/images/main/partner6.jpg)"></div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="thumb-wrap mb-10 mb-lg-20">
                                    <div class="thumb" style="background-image: url(/images/main/partner7.jpg)"></div>
                                </div>
                                <div class="thumb-wrap">
                                    <div class="thumb" style="background-image: url(/images/main/partner8.jpg)"></div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="thumb-wrap mb-10 mb-lg-20">
                                    <div class="thumb" style="background-image: url(/images/main/partner9.jpg)"></div>
                                </div>
                                <div class="thumb-wrap">
                                    <div class="thumb" style="background-image: url(/images/main/partner10.jpg)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainBanners from "@/components/client/main/main-banners.vue";
import MainSection from "@/components/client/main/main-section.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import MainNotice from "@/components/client/main/main-notice.vue";
import MainReference from "@/components/client/main/main-reference.vue";
import MainCardIcon from "@/components/client/main/main-card-icon.vue";
import ArrowBtn from "@/components/client/dumb/arrow-btn.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";

export default {
    components: {
        ClientPage,
        MainBanners,
        MainSection,
        MainVisual,
        PopupLayer,
        LocaleSelect,
        MainNotice,
        MainReference,
        MainCardIcon,
        ArrowBtn,
        TitPrimary,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.$nextTick(() => {
            var Partners = new Swiper(".partners-slide .swiper-container", {
                spaceBetween : 20,
                slidesPerView: 5,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 500,
                loop: true,
                navigation: {
                    prevEl: '.slide-btn--prev',
                    nextEl: '.slide-btn--next'
                },
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        spaceBetween : 10,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                },
            });
        });
    },
};
</script>

<style scoped>
.visual{
    width: 100%;
    height: 100vh;
    background-image: url(/images/main/visual.jpg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
/* Animation */
.text-ani {
    overflow: hidden;
    display:block;
}

.text-ani >*{
    display:block;
    opacity: 0;
    animation:textAni 1s ease forwards;
}

.text-ani-wrap .text-ani:nth-child(1) >* {
	animation-delay: 0.2s;
}
.text-ani-wrap .text-ani:nth-child(2) >* {
	animation-delay: 0.4s;
}
.text-ani-wrap .text-ani:nth-child(3) >* {
	animation-delay: 0.6s;
}
.text-ani-wrap .text-ani:nth-child(4) >* {
	animation-delay: 0.8s;
}

@keyframes textAni{
	0% {
		opacity:0;
		transform:translateY(100%);
	}
	100% {
		opacity:1;
		transform:translateY(0);
	}
}

.thumb-wrap{
    padding-top: calc((84 / 244) * 100%);
    border-radius: 50px;
    overflow: hidden;
}
</style>
